import React, { useEffect, useState } from "react";
import Cx from "classnames";

import styles from "./WordCounter.scss";

export default function WordCounter() {
  const inputName = "image_alt";
  const [el, setEl] = useState();
  const [count, setCount] = useState();
  let loop;

  const onChange = (element) => {
    const theElement = el || element;

    if (theElement) {
      setCount(
        theElement
          .textContent
          .trim()
          .split(/\s+/)
          .filter(Boolean)
          .length
      );
    }
  }

  const loadTrixEditor = () => {
    const element = document.querySelector(`trix-editor[input=${inputName}]`);

    if (element) {
      clearInterval(loop);
      setEl(element);
      onChange(element);
    }
  }

  useEffect(() => {
    // keep checking for the editor until it is instantiated
    if (!el)
      loop = setInterval(loadTrixEditor, 500);

    if (el)
      el.addEventListener("trix-change", onChange);

    return function cleanupWordCounterChange() {
      if (el)
        el.removeEventListener("trix-change", onChange);
    }
  }, [el]);

  if (typeof count !== "number") return null;

  return (
    <div className={Cx(styles.wrap, { [styles.warning]: (count > 15) })}>
      {`${count} / 15`}
    </div>
  );
}